const convertDateToHoursAndMinutes = (deliveryDateTime) => {
    const date = new Date(deliveryDateTime);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

export default convertDateToHoursAndMinutes;